import React from "react";
export default function DetailsTable({ t, index }) {
  const section = t.details[index];
  return (
    <details className="feature-details">
      <summary>
        {section.section}
        <span aria-hidden="true">+</span>
      </summary>
      <dl>
        {section.subsections.map((subsection) => (
          <div key={subsection.name}>
            <dt>{subsection.name}</dt>
            <dd>
              <ul>
                {subsection.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </dd>
          </div>
        ))}
      </dl>
    </details>
  );
}
